import { useEffect, useState } from 'react';
import { PlusIcon } from '@/utils/icons';
import s from './index.module.css';
import { Menu } from './components/Menu';
import { Content } from './components/Content';
import { nanoid } from 'nanoid';
import classNames from 'classnames';
import { MULTIPLICATION, FRACTION, SQUAREROOT, DIVIDE, ADDITION, SUBTRACTION, NTHROOT, MIXEDFRACTION } from './constants';

const Constructor = ({edit, value, prohibitEditing, onError = (v, n) => {}, validate, name='', className = ''}) => {
    const [isShowMenu, setIsShowMenu] = useState(false);
    const menuToggle = () => setIsShowMenu((prev) => !prev);
    const add = ({type}) => {
        console.log(value)
        console.log(type)
        if(type === FRACTION) {
            edit([...value,  { type, numerator: '', denominator: '', id: nanoid() } ])
        }
        if(type === MIXEDFRACTION) {
            edit([...value,  { type, wholePart: '', numerator: '', denominator: '', id: nanoid() } ])
        }
        if(type === MULTIPLICATION) {
            edit([...value,  { type, id: nanoid() } ])
        }
        if(type === SQUAREROOT) {
            edit([...value,  { type, value: '', id: nanoid() } ])
        }
        if(type === NTHROOT) {
            edit([...value,  { type, value: '', degree: '', id: nanoid() } ])
        }
        if(type === DIVIDE) {
            edit([...value,  { type, id: nanoid() } ])
        }
        if(type === ADDITION) {
            edit([...value,  { type, id: nanoid() } ])
        }
        if(type === SUBTRACTION) {
            edit([...value,  { type, id: nanoid() } ])
        }
        
    }

    const setError = (val) => {
        onError((prev) => {
            const items = { ...prev.items, [name]: val };
            let flag = true;
            for (let key in items) {
              if (items[key].value) flag = false;
            }
            return { items, valid: flag };
          });
    }

    useEffect(() => {
        if(!name) return;
        setError({value:!value.length})
    }, [value.length])

    return (
        <>
            <div className={classNames(s.constructorWrapper, className)}>
                {
                    isShowMenu && !prohibitEditing && <Menu {...{add, menuToggle}} />
                }
                {
                    !!value?.length && (
                        <Content {...{value, edit, prohibitEditing}} />
                    )
                }
                {
                    prohibitEditing && !value?.length && (
                       <span className={s.plaseholder}>Конструктор</span>
                    )
                }
                
                {
                    !prohibitEditing && <button 
                        type="button"
                        onClick={menuToggle}
                        className={s.openMenu}>
                        <PlusIcon />
                    </button>
                } 
                
            </div>
            {
                validate && !value.length && <span className={s.errorText}>Поле не заполнено</span>
            }
        </>
    );
};

export default Constructor;